import { render, staticRenderFns } from "./MaleApproval.vue?vue&type=template&id=5006fe5a&scoped=true&"
import script from "./MaleApproval.vue?vue&type=script&lang=js&"
export * from "./MaleApproval.vue?vue&type=script&lang=js&"
import style0 from "./MaleApproval.vue?vue&type=style&index=0&id=5006fe5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5006fe5a",
  null
  
)

export default component.exports